"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("./core/");
var _utils = require("./utils");
var defaultOpt = {
  beforeSend: function beforeSend(data) {
    (0, _utils.LogInfo)('beforeSend', data);
  },
  onLcp: function onLcp(data) {
    // LogInfo('onLcp', JSON.parse(JSON.stringify(data)))
  },
  onFmp: function onFmp(data) {
    // LogInfo('onFmp', data)
  },
  needAjax: true,
  needSource: true,
  needImg: true
};
var legoPerf = function legoPerf() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOpt;
  try {
    if (typeof window !== 'undefined') {
      (0, _core.initTask)(opts);
    }
  } catch (err) {
    console.error(err);
  }
};
var _default = legoPerf;
exports.default = _default;